import React, { useCallback, useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { Dialog, FlatButton, List, ListItem, CircularProgress, Checkbox, RaisedButton, IconButton } from 'material-ui';
import { formName } from '../../../data/formNames';
import { getAreasAtPoint } from 'services/regions/areas';

const styles = {
    dialog: {
        header: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '0px 0px -1px',
            padding: '24px 24px 20px',
        },
        title: {
            color: 'rgba(0, 0, 0, 0.87)',
            fontSize: '22px',
            lineHeight: '32px',
            fontWeight: '400',
        },
    },
};

/**
 * @typedef {{
 *  shown: boolean,
 *  onClose: (parents: string[]) => void,
 *  coordinates: [number, number],
 * }} Props
 * @type {import('react').FC<Props>}
 */
const AreaAutoAssignmentConfirmModal = ({ shown, onClose, coordinates }) => {
    const [areas, setAreas] = useState(null);
    const [checkedAreaIds, setCheckedAreaIds] = useState([]);
    
    useEffect(() => {
        if (!coordinates || coordinates.length != 2) return;
        setAreas(null);
        getAreasAtPoint(coordinates)
            .then(({ data }) => {
                setAreas(data);
                setCheckedAreaIds(data.map(area => area._id));
            });
    }, [coordinates]);

    const handleAccept = useCallback(() => {
        if (!areas) return;
        onClose(checkedAreaIds);
    }, [areas, checkedAreaIds, onClose]);

    const handleDecline = useCallback(() => {
        if (!areas) return;
        onClose([]);
    }, [areas, checkedAreaIds, onClose]);

    const handleCheck = useCallback((event, checked) => {
        const checkedId = event.target.value;
        if (checked) {
            setCheckedAreaIds([...checkedAreaIds, checkedId]);
        } else {
            setCheckedAreaIds(checkedAreaIds.filter(id => id != checkedId));
        }
    }, [checkedAreaIds]);

    const selectAll = useCallback(() => {
        setCheckedAreaIds(areas.map(a => a._id));
    }, [areas]);

    const selectNone = useCallback(() => {
        setCheckedAreaIds([]);
    }, []);

    return (
        <Dialog
            title={
                <React.Fragment>
                    <div style={styles.dialog.header}>
                        <div style={styles.dialog.title}>Add into areas</div>
                        <div>
                            <FlatButton
                                label="Select All"
                                secondary
                                onClick={selectAll}
                            />
                            <FlatButton
                                label="Select None"
                                secondary
                                onClick={selectNone}
                            />
                        </div>
                    </div>
                </React.Fragment>
            }
            open={shown}
            autoScrollBodyContent
            actions={
                areas && areas.length === 0 ? [
                    <FlatButton label="Continue" onClick={handleDecline} />,
                ] : [
                    <FlatButton label="No" onClick={handleDecline} />,
                    <FlatButton
                        label="Yes"
                        primary
                        keyboardFocused
                        onClick={handleAccept}
                        disabled={!areas}
                    />,
                ]
            }
        >
            {!!areas && areas.length > 0 && (
                <List>
                    {areas.map(area => (
                        <ListItem
                            key={area._id}
                            leftCheckbox={
                                <Checkbox
                                    onCheck={handleCheck}
                                    value={area._id}
                                    checked={checkedAreaIds.includes(area._id)}
                                />
                            }
                        >
                            {area.name}
                        </ListItem>
                    ))}
                </List>
            )}
            {!!areas && areas.length === 0 && (
                <div style={{ margin: '15px 0', textAlign: 'center' }}>
                    There is no areas at this point.
                </div>
            )}
            {!areas && (
                <CircularProgress />
            )}
        </Dialog>
    );
};

AreaAutoAssignmentConfirmModal.displayName = 'AreaAutoAssignmentConfirmModal';

const selectPortFormValue = formValueSelector(formName.portCreate);

export default connect(
    (state, ownProps) => {
        return {
            ...ownProps,
            coordinates: selectPortFormValue(state, 'coordinates'),
        };
    },
    dispatch => bindActionCreators({
    }, dispatch),
)(AreaAutoAssignmentConfirmModal);



// WEBPACK FOOTER //
// ./app/components/Regions/PortAdd/AreaAutoAssignmentConfirmModal.jsx